import { primaryEndpoint } from './askSite';

const COMPOSE_TIMEOUT_MS = 60000;
const SPEECH_TIMEOUT_MS = 75000;

function timedSignal(ms, externalSignal) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  const abort = () => controller.abort();
  externalSignal?.addEventListener('abort', abort, { once: true });
  return {
    signal: controller.signal,
    cancel() {
      clearTimeout(timer);
      externalSignal?.removeEventListener('abort', abort);
    },
  };
}

async function roomFetch(path, body, timeout, externalSignal) {
  const endpoint = primaryEndpoint();
  if (!endpoint) throw new Error('room_unavailable');
  const request = timedSignal(timeout, externalSignal);
  try {
    return await fetch(`${endpoint}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: request.signal,
      cache: 'no-store',
    });
  } finally {
    request.cancel();
  }
}

export async function composeRoom(fragment, signal) {
  const response = await roomFetch('/room/compose', { fragment }, COMPOSE_TIMEOUT_MS, signal);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.scene) throw new Error(payload.error || 'composition_unavailable');
  return payload.scene;
}

export async function synthesiseRoomLine({ text, voiceId, language, allowReplacement }, signal) {
  const response = await roomFetch('/room/speech', {
    text,
    voice_id: voiceId,
    language,
    allow_replacement: allowReplacement,
  }, SPEECH_TIMEOUT_MS, signal);
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || 'speech_unavailable');
  }
  return {
    bytes: await response.arrayBuffer(),
    voiceId: response.headers.get('X-Room-Voice-ID') || voiceId,
  };
}
